import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function ViewRecord({
  size = sizes.X_LARGE,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12.8013 7.57138L5.16007 1.60317C5.1401 1.58745 5.1161 1.57768 5.09084 1.57498C5.06557 1.57228 5.04005 1.57677 5.01722 1.58792C4.99438 1.59907 4.97516 1.61644 4.96175 1.63803C4.94834 1.65961 4.94129 1.68454 4.94141 1.70995V3.02021C4.94141 3.10327 4.98039 3.18294 5.0448 3.23379L11.1469 7.99853L5.0448 12.7633C4.9787 12.8141 4.94141 12.8938 4.94141 12.9768V14.2871C4.94141 14.4007 5.07193 14.4634 5.16007 14.3939L12.8013 8.42568C12.8662 8.37502 12.9188 8.31021 12.9549 8.2362C12.991 8.16218 13.0098 8.0809 13.0098 7.99853C13.0098 7.91616 12.991 7.83488 12.9549 7.76086C12.9188 7.68684 12.8662 7.62204 12.8013 7.57138Z"
        fill={colour}
      />
    </svg>
  )
}

ViewRecord.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
